import DetailsEmpty from "./DetailsEmpty";
import ListDetailsOrder from "./ListDetailsOrder";
import ListDetailsActions from "./ListDetailsActions";
import ListDetailsNotes from "./ListDetailsNotes";

const ListDetails = ({ orders }) => {
    if (!orders.length) return <DetailsEmpty />

    return (
        <div className="bg-white overflow-hidden sm:rounded-lg">
            {orders.map((order) => (
                <>
                    <ListDetailsNotes order={order} />
                    <ListDetailsOrder order={order} />
                </>
            ))}
        </div>
    )
}

export default ListDetails
